export default __webpack_public_path__ + "static/gameAccountBg-23ee5fa9fb701785b26a7ad64e14ef4d.png";